/*! Goldtop - where the Klarna badge sits on the PDP.
    Loaded after the controller on every product page, from
    snippets/gt-pdp-v2.liquid.

    THE FILENAME LAGS THE REMIT, and the history is worth keeping because it is
    the useful part of this file.

    It was written on 26 Sep to hide the Klarna wordmark. The placement in use
    then was data-key="credit-promotion-badge", which draws a boxed Klarna logo
    to the left of the instalment line, and the only way to remove it was to
    inject a <style> into the placement's open shadow root - a document
    stylesheet cannot cross that boundary. It worked, and it was recorded at the
    time that stripping a Klarna-rendered wordmark is likely contrary to their
    merchant placement terms, with the realistic downside being Klarna switching
    off on-site messaging for the account.

    THAT HACK IS GONE, AND SO IS THE RISK. Joe asked the same day for the word
    KLARNA to be set in the font hedon.com uses. Reading their page settled it:
    they are not styling anything. They run a DIFFERENT PLACEMENT -
    data-key="credit-promotion-auto-size" - which has no badge container and no
    SVG at all, and renders "Klarna" inline in Klarna's own "Klarna Headline"
    webfont, shipped by Klarna inside the shadow root.

    So the answer was an app-block setting, not CSS and not a webfont: data_key
    changed from credit-promotion-badge to credit-promotion-auto-size on every
    template. Measured on the gloves preview afterwards - 11 shadow nodes, zero
    SVGs, no .badge-container, and two .logo spans in "Klarna Headline" at
    14.25px/700, identical to Hedon's. The shadow-root style injection was then
    deleted rather than left in as an inert no-op: a rule that silently hides a
    badge would be a trap for whoever next switches the placement back.

    Renaming the file would mean re-relaying a 14KB snippet to change one line,
    which is not worth it. Fold this into the controller the next time that file
    is opened through the Shopify code editor.

    ------------------------------------------------------------------
    WHAT IT DOES NOW. Joe, 26 Sep: "The klarna information section needs to sit
    as the next thing below the ADD TO CART or NOTIFY ME WHEN BACK IN STOCK
    buttons across all templates. Currently it is sitting below the judge review
    blocks, or sometimes even below the trust icons."

    DESKTOP WAS ALREADY RIGHT and is left alone. Measured at 1437px on The Bobber
    Jacket: the buy block is index 7 in the meta column and the Klarna app block
    is index 8, immediately after it, with the four trust rows below. That is
    block_order doing its job, because the mobile controller does not run at that
    width.

    MOBILE WAS NOT. Measured at a real 375px on the same product:

      gt-buy      top  687  h 627
      gt-reviews  top 1346  h  81     the judge.me rail
      sales-point top 1459  h  20  |
      sales-point top 1490  h  20  |  the four trust rows
      sales-point top 1522  h  20  |
      sales-point top 1553  h  20  |
      gt-klarna   top 1597  h  94     283px below the button

    The controller's moveKlarna() wraps the app block in .gt-klarna but leaves it
    where the template put it, while the buy button is hoisted up into .gt-buy.
    Everything that was between them in block_order ends up between them on the
    page. Hence Joe seeing it under the reviews on one product and under the
    trust icons on another: it depends on what that template happens to list.
    No amount of block_order editing fixes this, because block_order is not what
    is moving things.

    So .gt-klarna is moved to be the next sibling after .gt-buy. Measured after:
    the gap closes from 283px to 32px, which is the same rhythm the review rail
    already sits in, and the order becomes buy / Klarna / reviews / trust.

    NOTIFY ME NEEDS NO SPECIAL CASE. A sold-out product still builds .gt-buy -
    only the button's wording changes - so the placement follows it.

    ------------------------------------------------------------------
    28 SEP: THE BAG DID NEED A SPECIAL CASE, AND THIS IS IT.

    The paragraph that used to sit here said a bag needed none, because
    moveKlarna() returns at its second line when there is no .gt-buy, so
    .gt-klarna is never created and there is nothing to move. All true, and the
    conclusion drawn from it was wrong: nothing to move is not the same as
    nothing wrong.

    Joe, 28 Sep: "on the wallet product, the KLARNA segment is below the reviews
    carousel."

    MEASURED at a real 375x812 on the Horizontal Leather Billfold Wallet:

      add to cart   top  764  h 56   (ends 820)
      gt-reviews    top  852  h 81   the judge.me rail
      klarna        top  966  h 22   146px below the button

    THE TEMPLATE IS NOT THE PROBLEM, which is worth saying because it is the
    first place anyone would look. The wallet runs the default templates/
    product.json, and in that file the Klarna app block is index 9 and
    buy_buttons is index 8 - already adjacent, already correct. Confirmed in the
    rendered DOM too: the Klarna block IS the immediate next sibling of the
    block that holds the buy button.

    WHAT IS ACTUALLY BETWEEN THEM IS INSIDE THAT BLOCK. The controller injects
    the review rail into the buy-buttons block, after the form. So the order
    within one block is form / reviews, and Klarna - correctly placed after the
    whole block - lands after both. No amount of block_order editing reaches it.

    WHICH PRODUCTS. Not a template and not a bag: it is every product the
    controller does not build a .gt-buy for. Driven at 375px:

      horizontal-leather-bifold-wallet   Color            no .gt-buy   BROKEN
      leather-tank-bag-small             Colour           no .gt-buy   BROKEN
      100-merino-wool-beanie             Colour           no .gt-buy   BROKEN
      sweater-stone                      Title (1 variant) no .gt-buy  BROKEN
      water-repellent-balm               Tin Size         .gt-buy      fine
      premium-cotton-neck-tube           Colour + Size    .gt-buy      fine
      elbow-shoulder-armour              Style            .gt-buy      fine

    So .gt-buy follows the CHIP rail, not the size rail: a product whose only
    option is a colour, or which has no real option at all, never gets one. On
    this catalogue that is about twenty colour-only products - the tank bags,
    the caps, the wallets, the card holder, the beanie, the messenger and
    weekend bags - plus the single-variant accessories.

    THE FIX BUILDS THE SAME WRAPPER THE CONTROLLER WOULD HAVE. placeByForm()
    creates a .gt-klarna div, puts the Klarna app block inside it, and inserts
    it between the form and the review rail. Building the wrapper rather than
    moving the bare app block is not tidiness: gt-pdp-v2.css and
    gt-pdp-v2-sheet.css style .gt-klarna and its children, and the spacing only
    comes out right when the structure matches what those rules were written
    for. Measured after the move: margin 24px top, 32px bottom, computed
    identical to the Predator's, and the button-to-Klarna gap 24px against the
    Predator's 24px.

    IT CANNOT FIRE ON DESKTOP, without a width test. The guard is that
    .gt-reviews exists - that rail is built by the controller, and the
    controller does not run above 768px. Verified on the same wallet at 1440px:
    html carries "js" alone, no gt-v2, no .gt-reviews, no .gt-bar2, and Klarna
    is already 26px under the button from block_order alone. That is the same
    reasoning the .gt-buy path uses, and it is preferred to a matchMedia here
    for the same reason: a test for the thing itself cannot drift out of step
    with the controller's own breakpoint.

    IT DOES NOT FIGHT THE CONTROLLER. Verified on the preview: after the move the
    wrapper was still the buy block's next sibling 2.5 seconds later, so
    moveKlarna() does not put it back. The already-in-place guard means the
    observer's own re-entry is a no-op rather than a loop.

    PURE ASCII, working rule 18: the theme-file connector has mangled non-ASCII
    twice.
*/
(function () {
  "use strict";

  /* Mobile only in practice, because .gt-klarna is the wrapper the controller
     builds and the controller only runs below 768px. No width test here on
     purpose: the condition that matters is whether the wrapper exists, and
     testing for it directly cannot drift out of step with the controller's own
     breakpoint. */
  function place() {
    var kw, buy;
    try {
      kw = document.querySelector(".gt-klarna");
      buy = document.querySelector(".gt-buy");
    } catch (e) { return; }
    if (!kw || !buy) return;                           /* desktop, or a bag */
    if (buy.nextElementSibling === kw) return;         /* already right - and this
                                                          is what stops the
                                                          observer that our own
                                                          move triggers from
                                                          becoming a loop */
    if (kw.contains(buy) || buy.contains(kw)) return;  /* never reparent into self */
    if (buy.parentNode !== kw.parentNode) return;      /* not the shape we measured */
    try { buy.parentNode.insertBefore(kw, buy.nextSibling); } catch (e) {}
  }

  /* The shape with no .gt-buy - a colour-only or single-variant product. See
     the header. This never runs on the measured shape, because the first guard
     hands those back to place(), and it never runs on desktop, because
     .gt-reviews only exists while the controller is running. */
  function placeByForm() {
    var k, form, blk, wrap;
    try {
      k = document.querySelector("klarna-placement");
      form = document.querySelector("form.product-single__form");
    } catch (e) { return; }
    if (!k || !form) return;
    if (document.querySelector(".gt-buy")) return;      /* place() owns that shape */
    if (!document.querySelector(".gt-reviews")) return; /* desktop, or no rail to
                                                           be stuck behind - in
                                                           which case block_order
                                                           has already got it
                                                           right on its own */

    wrap = k.closest(".gt-klarna");
    if (wrap) {
      /* Built on an earlier pass. Only its position can be wrong now. */
      if (form.nextElementSibling === wrap) return;     /* already right, and this
                                                           is what stops the
                                                           observer our own move
                                                           triggers from looping */
      if (wrap.contains(form)) return;                  /* never reparent into self */
      try { form.parentNode.insertBefore(wrap, form.nextSibling); } catch (e) {}
      return;
    }

    blk = k.closest(".shopify-app-block");
    if (!blk || blk.contains(form)) return;
    try {
      wrap = document.createElement("div");
      wrap.className = "gt-klarna";
      form.parentNode.insertBefore(wrap, form.nextSibling);
      wrap.appendChild(blk);
    } catch (e) {}
  }

  function run() { place(); placeByForm(); }

  /* Debounced, because the observer below watches the whole document and the
     page mutates constantly - the controller alone rewrites the buy bar on
     every variant change. */
  var t = null;
  function soon() { clearTimeout(t); t = setTimeout(run, 50); }

  function start() {
    run();
    if (window.MutationObserver) {
      new MutationObserver(soon).observe(document.documentElement, {
        childList: true, subtree: true
      });
    }
    /* The controller builds .gt-buy and .gt-klarna after its own first pass, so
       the first call usually finds nothing. Same shape of retry ladder the
       controller uses. */
    [200, 600, 1200, 2500, 5000].forEach(function (d) { setTimeout(run, d); });
    document.addEventListener("change", soon, true);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
